export default __webpack_public_path__ + "static/media/IconCogwheelInactive.ad8b7dfc.svg";